<template>
  <el-container class="main-container">
    <el-aside class="aside sidebar" :class="{ 'is-collapse': isCollapse || isIframeMode }" width="200px">
      <app-aside :is-collapse="isCollapse" />
    </el-aside>
    <el-container>
      <el-header v-show="!isIframeMode">
        <el-row class="header">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" @click="isCollapse = !isCollapse" class="logo-panel">
            <el-icon>
              <Expand v-show="isCollapse" />
              <Fold v-show="!isCollapse" />
            </el-icon>
            <span> {{ $store.getters.getWebSetting.projectName }} </span>
          </el-col>
          <el-col :xs="24" :sm="12" :md="18" :lg="18" :xl="18" class="content-panel">
            <div class="newsbox">
              <!-- <el-button plain icon="StarFilled" @click="$router.push({ path: '/workflow/articlePaper', query: { type: '' } })">通知</el-button> -->
              <!-- <el-button plain icon="Message">1</el-button> -->
              <el-carousel height="50px; line-height: 50px;" autoplay v-if="newsDatas && newsDatas.length > 0"
                arrow="always">
                <el-carousel-item v-for="item in newsDatas" :key="item"
                  style="height: 36px; line-height: 18px;cursor: pointer;"
                  @click="$router.push({ name: 'articleDetail', query: { id: item.id } })">
                  <h3>
                    <bold v-if="item.articleType">[{{ item.articleType }}]</bold>
                    {{ item.title }}
                  </h3>
                  <div style="text-align: right;">发布:{{ item.publishUserName }} 时间:{{ $util.fmtDate(item.publishDate,
                    "yy-MM-dd HH:mm") }}</div>
                </el-carousel-item>
              </el-carousel>
            </div>

            <div v-if="goldenDatas && goldenDatas.length > 0" class="goldenbox" hidden-xs-only hidden-sm-only>
              <el-carousel height="50px; line-height: 50px;" v-if="goldenDatas && goldenDatas.length > 0"
                style="text-align: center;" direction="horizontal" type="card" autoplay :initial-index="0"
                :cardScale="0.7" :interval="4500" arrow="always">
                <el-carousel-item v-for="item in goldenDatas" :key="item" style="height: 36px; line-height: 18px;">
                  <div style="color:red">{{ item.purity }}&nbsp;&nbsp;￥{{ item.goldPrice }}</div>
                  <div>{{ $util.fmtDate(item.goldTime, "MM-dd HH:mm") }}</div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <el-text @click="fullscreenEnabled">
              <el-icon>
                <FullScreen />
              </el-icon>
            </el-text>
            <!-- <el-text>测试 </el-text> -->
            <el-dropdown v-if="sidemenus && sidemenus.length > 0">
              <el-text>
                <el-icon>
                  <Platform />
                </el-icon>
              </el-text>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="item in sidemenus">
                    <a :href="item.value" target="_blank">{{ item.name }}</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <!-- <el-text> | </el-text> -->
            <el-badge :value="unreadMsgCount > 0 ? unreadMsgCount : ''" :hidden="unreadMsgCount === 0" :max="99"
              class="message-badge" @click="goToMessage">
              <el-icon>
                <Bell />
              </el-icon>
            </el-badge>

            <el-dropdown>
              <el-text style="min-width:50px;">
                {{ $store.getters.getUserInfo.userName || '更多设置' }}
                <el-icon>
                  <ArrowDown />
                </el-icon>
              </el-text>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="userSetting()">个人信息</el-dropdown-item>
                  <el-dropdown-item @click="clearEvent()">清理缓存</el-dropdown-item>
                  <el-dropdown-item @click="resetEvent()">重置密码</el-dropdown-item>
                  <el-dropdown-item divided @click="logoutEvent()">
                    退 出
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- <el-footer>Footer</el-footer> -->
    </el-container>
  </el-container>

  <!-- <div class="dialog">
    <resetPwdDialog :visible="resetDialogVisible"></resetPwdDialog>
  </div> -->
  <static-dialog ref="resetDialog" class="dialog" title="重置密码" :ok="resetPwdEvent">
    <resetPwdDialog :visible="true" :user="currRow" ref="resetPwdDialogRef"></resetPwdDialog>
  </static-dialog>


  <static-dialog ref="userDialog" class="dialog" title="个人设置" :okVisible="false">
    <el-form :model="forms" ref="forms" label-width="90px">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="公司" prop="companyName">
            <el-input v-model="forms.companyName" autocomplete="off" disabled> </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="部门" prop="departmentName">
            <el-input v-model="forms.departmentName" autocomplete="off" disabled> </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="账户" prop="account">
            <el-input v-model="forms.account" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="forms.realName" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="性别" prop="gender" class="gender" disabled>
            <el-radio v-model="forms.gender" label="男">男</el-radio>
            <el-radio v-model="forms.gender" label="女">女</el-radio>
            <el-radio v-model="forms.gender" label="无">无</el-radio>
            <!-- <el-radio-group v-model="forms.gender" disabled>
              <el-radio label="男" />
              <el-radio label="女" />
              <el-radio label="无" />
            </el-radio-group>-->
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="手机" prop="mobile">
            <el-input v-model="forms.mobile" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item label="生日" prop="birthday">
            <el-date-picker v-model="forms.birthday" type="date" placeholder="选择生日" format="YYYY-MM-DD"
              :editable="false" disabled>
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </static-dialog>
</template>

<script>
import store from "@/store";
import StaticDialog from "@/components/static-dialog.vue";
import AppAside from "./components/aside";
import resetPwdDialog from "@/views/sys/user/reset.vue";

import { currentMenus, webSetting, currentUser } from "@/api/sys";
import { logout } from "@/api/login";

import 'element-plus/theme-chalk/display.css'
import { fa } from "element-plus/es/locales.mjs";

export default {
  name: "LayoutIndex",
  components: {
    AppAside, StaticDialog, resetPwdDialog
  },
  props: {},
  data() {
    return {
      fullscreen: false,
      isCollapse: false,
      isIframeMode: false, // 是否在iframe模式

      sidemenus: null,
      forms: {},
      rules: {
        oldpassword: [
          { min: 0, max: 30, message: "请输入账号原密码", trigger: "blur", },
        ],
        newpassword: [
          { min: 4, max: 30, message: "密码长度不符合要求", trigger: "blur", },
        ],
        confirmpassword: [
          { min: 4, max: 30, message: "密码长度不符合要求", trigger: "blur", },
        ],
      },

      goldenDatas: [],
      newsDatas: [],
      unreadMsgCount: 0, // 未读消息数量
      messageTimer: null, // 定时器
    };
  },
  methods: {
    // 检测是否在iframe模式
    checkIframeMode() {
      // 检查是否在iframe中（判断当前窗口是否为顶级窗口）
      this.isIframeMode = window.self !== window.top;
    },

    // openPwd() {
    //   this.$refs.dialog.toggle();
    // },
    // resetPwd() {
    //   let that = this;
    //   this.$refs.forms.validate((valid) => {
    //     if (!valid) return;

    //     if (!!!that.forms.newpassword) {
    //       that.$message.error("请输入新旧密码~");
    //       return;
    //     }

    //     if (that.forms.newpassword != that.forms.confirmpassword) {
    //       that.$message.error("两次输入新密码不一致~");
    //       return;
    //     }

    //     resetUserPwd(this.forms).then((res) => {
    //       if (res.code === 200) {
    //         that.$message({ type: "success", message: res.content, });
    //         setTimeout(function () {
    //           that.logout();
    //         }, 1000);
    //       }
    //     });
    //   });
    // },

    fullscreenEnabled() {
      if (!this.fullscreen) {
        //启动全屏
        const element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
        this.fullscreen = true;
      } else {
        //退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
        this.fullscreen = false;
      }
    },

    setAppWidth() {
      var val = document.body.clientWidth
      const def = 800 // 默认宽度
      if (val < def) {
        this.isCollapse = true
      } else {
        this.isCollapse = false
      }
    },
    resetEvent() {
      this.$refs.resetDialog.toggle();
    },
    resetPwdEvent() {
      this.$refs.resetPwdDialogRef.resetPwd(true);
    },
    logoutEvent() {
      logout();
    },
    clearEvent() {
      this.$confirm("清理缓存将导致页面填写内容丢失，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$util.setLocalstorage('version', Math.floor(Math.random() * Math.pow(10, 4)));
          setTimeout(() => {
            location.reload();
          }, 500);
        });
    },

    userSetting() {
      this.$refs.userDialog.toggle();//打开
      this.forms = this.$store.getters.getUserInfo;
    },

    goldenData() {
      this.$kaung.fetch({ url: '/GoldenData', method: 'get', loading: false, cache: 60 * 10 }).then((res) => {
        this.goldenDatas = res.data;
      });
    },
    newsData() {
      this.$kaung.fetch({
        url: '/FlowArticle/PublicList', method: 'post', params: {
          rows: 5,
          //market: "5"
        },
        cache: 60 * 30 //30分钟的缓存
      }).then((res) => {
        this.newsDatas = res.data.data;
      });
    },

    // 获取未读消息数量
    getUnreadMessageCount() {
      this.$kaung.fetch({
        url: '/BaseUser/Dashboard', method: 'get', loading: false, cache: 50,//50s
      }).then((res) => {
        this.unreadMsgCount = res.data.unreadCount || 0;
      }).catch((err) => {
        console.log('获取未读消息数量失败:', err);
        this.unreadMsgCount = 0;
      });
    },

    // 点击消息图标
    goToMessage() {
      this.$router.push({ path: '/sys/message' });
      // 延迟刷新未读消息数量，给用户一些时间查看消息
      setTimeout(() => {
        this.getUnreadMessageCount();
      }, 2000);
    },

    // 启动定时刷新未读消息数量
    startMessageTimer() {
      // 每5分钟刷新一次未读消息数量
      this.messageTimer = setInterval(() => {
        this.getUnreadMessageCount();
      }, 30 * 1000);
    },
  },
  watch: {
    // 监听路由变化，检测iframe模式
    '$route'(to, from) {
      this.checkIframeMode();

      // 如果从消息页面返回，刷新未读消息数量
      if (from.path === '/sys/message' || from.path.startsWith('/sys/message/')) {
        setTimeout(() => {
          this.getUnreadMessageCount();
        }, 1000);
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setAppWidth()
      })()
    }
  },
  beforeCreate() {
    currentUser().then((res) => {
      store.commit("setUserInfo", res);
      //console.log(that.$store.getters.getUserInfo);
    });
    webSetting().then((res) => {
      store.commit("setWebSetting", res);
      //console.log(res);
    });

    currentMenus('侧边栏').then((res) => {
      this.sidemenus = res;
    });
  },
  created() {
    this.setAppWidth()
    this.checkIframeMode() // 检测iframe模式

    this.goldenData();
    this.newsData();
    this.getUnreadMessageCount(); // 获取未读消息数量
    this.startMessageTimer(); // 启动定时刷新
  },
  beforeUnmount() {
    // 清理定时器
    if (this.messageTimer) {
      clearInterval(this.messageTimer);
      this.messageTimer = null;
    }
  }
};
</script>
<style scoped lang="less">
.main-container {
  width: 100%;
  height: 100%;
}

.aside {
  transition: transform 0.25s ease-in-out, width 0.25s ease-in-out;
  overflow: hidden;
  will-change: transform, width;
  transform: translateX(0);

  &.is-collapse {
    width: 0 !important;
    transform: translateX(-200px);
    padding: 0;
    margin-left: 0;
  }
}

.header {
  height: 60px;
  justify-content: space-between;
  align-items: center;
}

.logo-panel {
  cursor: pointer;
}

// cursor: pointer;
.content-panel {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-end;

  .newsbox {
    height: 40px;
    width: 200px;
    overflow: hidden;
    font-size: 0.9em;
    border-right: 1px solid #000;
    padding-right: 15px;
    color: #515a6e;
  }

  .goldenbox {
    height: 40px;
    width: 250px;
    margin-top: 5px;
    overflow: hidden;
    font-size: 0.8em;
    border-right: 1px solid #000;
    margin-right: 10px;
  }

  .el-text {
    line-height: 50px;
    margin: 0 7px;
    cursor: pointer;
    color: #000;

    .el-icon {
      vertical-align: 0;
    }
  }

  .el-badge {
    line-height: 50px;
    margin: 0 7px;
    cursor: pointer;
    color: #000;
    margin-right: 20px;

    .el-icon {
      vertical-align: 0;
    }

    :deep(.el-badge__content.is-fixed) {
      top: calc(10px + var(--el-badge-size)/2);
    }
  }

}

.el-main {
  background-color: #f6f8f9;
  color: #515a6e;
}

@media screen and (max-width: 1200px) {
  .el-main {
    padding: 0;
  }

  .newsbox {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .el-main {
    padding: 0;
  }

  .content-panel {
    display: none;
  }
}

.header .el-icon {
  top: 4px;
  position: relative;
  font-size: 1.2em;
}
</style>